import {FC, useContext, useEffect, useRef, useState} from "react";
import Card from "../../components/ui/Card";
import Select from "../../components/ui/Select";
import {AppContext} from "../../context/AppContext";
import Button from "../../components/ui/Button";
import {FaSave} from "react-icons/fa";
import {toast} from "react-hot-toast";
import useApi from "../../hooks/useApi";
import {IToken} from "../../types/ApiTypes";
import TokenList from "../../components/admin/settings/TokenList";
import handleToastError from "../../helpers/handleToastError";
import TokenModal from "../../components/admin/settings/TokenModal";

const possibleSettings = [
    {label: 'Manuell', value: 'manual'},
    {label: 'Integriert', value: 'integrated'}
]

const Settings: FC = () => {
    const mounted = useRef(false);
    const [approvalType, setApprovalType] = useState<'integrated'|'manual'>('integrated');
    const {changeAppSettings, getApiTokens} = useApi();
    const {state: {settings}, dispatch} = useContext(AppContext);

    const [tokens, setTokens] = useState<IToken[]>([]);
    const [newTokenModalOpen, setNewTokenModalOpen] = useState(false);

    useEffect(() => {
        mounted.current = true;
        return () => {mounted.current = false}
    },[])

    useEffect(() => {
        getApiTokens().then(tokens => {
            if(tokens && mounted.current) {
                setTokens(tokens);
            }
        })
    },[getApiTokens])

    useEffect(() => {
        setApprovalType(settings.approvalTool);
    },[settings.approvalTool])

    const onApprovalTypeChange = (selected: {label: string, value: string}) => {
        setApprovalType(selected.value as 'manual'|'integrated');
    }

    const saveSettings = async () => {
        await toast.promise(changeAppSettings({
            approvalTool: approvalType
        }),{
            loading: 'Die Einstellungen werden gespeichert ...',
            success: (settings) => {
                if(settings && mounted.current) dispatch({type: 'SET_SETTINGS', payload: settings});
                return <span className='text-sm'>Die Einstellungen wurden geändert</span>
            },
            error: (err) => handleToastError(err, "Die Einstellungen konnten nicht geändert werden")
        });
    }

    const onTokenCreated = (token: IToken) => {
        setTokens(prev => [...prev, token]);
    }

    return (
        <>
            <Card title='Einstellungen'>
                <div>
                    <label className='font-semibold' htmlFor='Kunde'>Space Bestätigungstool</label>
                    <Select options={possibleSettings} defaultValue={possibleSettings.find(x => x.value === approvalType)} onChange={onApprovalTypeChange}/>
                    <small>Für manuelles handeln können Flows vor dem Erstellen eines Spaces verwendet werden</small>
                </div>
                <div className='mt-2 flex justify-end'>
                    <Button className='bg-success-darker hover:shadow-success-darker/20' onClick={saveSettings}><FaSave className='mr-1'/> Übernehmen</Button>
                </div>
            </Card>
            <Card title='API Tokens'>
                <TokenList tokens={tokens}/>
                <div className='mt-2 flex justify-end'>
                    <TokenModal onTokenCreated={onTokenCreated}/>
                </div>
            </Card>
        </>
    );
};

export default Settings;